// removed by extract-text-webpack-plugin
module.exports = {"root":"_14A2lgYFKioiQpmqR3PUBd","statusMessage":"v_UvjZ-rP3hLzgAOWtB3l","wrapper":"_2n5-BgKY0IUx2kocND-uu","resetPasswordBox":"_3tUEEGV_9AUGzdkTKePP7E","logo":"_2bXWFxiD-9m_qXJdqww47z","title":"_1cTKM731Qt5cMId3r664eg","buttonRow":"lciSGBzMyweXNyzSM-my1"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PasswordRecovery/style.css
// module id = 1103
// module chunks = 0